import type { components } from '@fluencelabs/vodopad-admin-api'
import { useCustom } from '@refinedev/core'

import { VODOPAD_ENDPOINT } from '@/constants/constants'
import type { PaginatedItems } from '@/types/api'

type UserPublicIpDto = components['schemas']['UserPublicIpDto']

interface Params {
  userId: string
  clusterId: string
  enabled?: boolean
}

// The attach pool. Admin list has no excludeAttached, so the unattached
// filter is client-side.
export function useAvailablePublicIps({
  userId,
  clusterId,
  enabled = true,
}: Params) {
  const result = useCustom<PaginatedItems<UserPublicIpDto>>({
    url: `${VODOPAD_ENDPOINT}/v1/admin/public_ips`,
    method: 'get',
    config: {
      query: { userId, clusterId, status: 'ready', page: 1, perPage: 100 },
    },
    queryOptions: {
      enabled: enabled && Boolean(userId) && Boolean(clusterId),
    },
  })

  const items =
    (result.query.data?.data as PaginatedItems<UserPublicIpDto> | undefined)
      ?.items ?? []

  return {
    available: items.filter((ip) => !ip.attachedTo),
    isLoading: result.query.isLoading,
    refetch: result.query.refetch,
  }
}
